import { render, staticRenderFns } from "./DocumentCloudFileUpload.vue?vue&type=template&id=5a9e4f6d&scoped=true&"
import script from "./DocumentCloudFileUpload.vue?vue&type=script&lang=js&"
export * from "./DocumentCloudFileUpload.vue?vue&type=script&lang=js&"
import style0 from "./DocumentCloudFileUpload.vue?vue&type=style&index=0&id=5a9e4f6d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9e4f6d",
  null
  
)

export default component.exports